import SideMenu from '@/containers/side-menu/SideMenu.vue';
import PrintConfig from '../pages/print-config/PrintConfig.vue';

export default {
  path: '/print-config',
  name: 'PrintConfig',
  components: {
    mainContent: PrintConfig,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'roles',
    },
    breadcrumb: {
      title: 'Configurações',
      paths: [{ title: 'Impressão' }],
    },
  },
};
